import ServiceBase from "@app/shared/serviceBase";
import { querystringify } from "@app/shared/utility/querystringify";
import {
  BatchProjectStatus,
  ClientDataShareSummary,
  NextRunProject,
  ProjectsInNextRunSummary,
  RefreshHealthSummary,
  SharingRunBatch,
} from "@app/operations/snowflake-data-sharing/interfaces";
import { TriggerListingRefreshOutcome } from "@app/operations/snowflake-data-sharing/enums";

export class SnowflakeDataSharingService extends ServiceBase {
  public async getDataShareClientDashboard(signal?: AbortSignal): Promise<ClientDataShareSummary[]> {
    return this.makeGet<ClientDataShareSummary[]>(
      "datashare/client-summary",
      undefined, undefined, undefined, undefined,
      signal,
    );
  }

  public async getNextRunProjects(clientId: number, signal?: AbortSignal): Promise<NextRunProject[]> {
    return this.makeGet<NextRunProject[]>(
      `datashare/${clientId}/next-run`,
      undefined, undefined, undefined, undefined,
      signal,
    );
  }

  public async getProjectsInNextRun(): Promise<ProjectsInNextRunSummary> {
    return {
      clientCount: 4,
      projectCount: 20,
    };
  }

  public async getRefreshSummary(): Promise<RefreshHealthSummary> {
    return {
      lastRefreshTime: "2026-07-17T15:00:00Z",
      totalProjectsInDataShare: 5,
      unresolvedFailures: 1,
    };
  }

  public async getBatches(clientId: number, publishedTimestamp: string, signal?: AbortSignal): Promise<SharingRunBatch[]> {
    const query = { publishedTimestamp };
    return this.makeGet<SharingRunBatch[]>(
      `datashare/${clientId}/get-batches?${querystringify(query)}`,
      undefined, undefined, undefined, undefined,
      signal,
    );
  }

  public async getBatchProjectStatuses(clientId: number, batchId: string, signal?: AbortSignal): Promise<BatchProjectStatus[]> {
    return this.makeGet<BatchProjectStatus[]>(
      `datashare/${clientId}/batches/${encodeURIComponent(batchId)}/projects`,
      undefined, undefined, undefined, undefined,
      signal,
    );
  }

  public async triggerListingRefresh(clientId: number): Promise<TriggerListingRefreshOutcome> {
    return this.makePost<TriggerListingRefreshOutcome>(`datashare/${clientId}/trigger-refresh`);
  }

  /** Queues the export job that unloads every share view to CSV. Resolves with the queued job id. */
  public async queueViewExport(clientId: number): Promise<number> {
    return this.makePost<number>(`datashare/${clientId}/views/export`);
  }
}
